import { USER_STATUS } from 'constants/status';

export const getProfileStatus = (profileStatus?: string): string => {
  switch (profileStatus) {
    case USER_STATUS.accountProcessing:
    case USER_STATUS.active:
    case USER_STATUS.accountCreationFailed:
      return USER_STATUS.idvApproved;
    default:
      return profileStatus ?? USER_STATUS.draft;
  }
};
